import { useEffect, useState } from 'react';

import classNames from 'classnames';

// cspell:disable-next-line -- disables checking till the end of the next line.
import type { AuthWebflowContentSchemaNullable } from '@iconik-io/iconik-api/src/services/auth';

import {
  MANAGED_SIGNUP_PAGE_ROUTE,
  REGISTRATIONS_VERIFY_PAGE_ROUTE,
  SIGNUP_PAGE_ROUTE,
} from '../../constants/routes';
import { getPromosContent } from '../../ducks/promos/thunks';
import { useAppDispatch, useAppSelector } from '../../store/react_redux_typed';
import type { FCC } from '../../types/common';
import PromoSlide from './promo_slide';

import styles from './promo.module.css';

const Promo: FCC = ({ children }) => {
  const route = useAppSelector((state) => state.routeParams.route);
  const isSignupForm = [
    SIGNUP_PAGE_ROUTE,
    MANAGED_SIGNUP_PAGE_ROUTE,
    REGISTRATIONS_VERIFY_PAGE_ROUTE,
  ].includes(route);

  const dispatch = useAppDispatch();

  const [slideContent, setSlideContent] =
    // cspell:disable-next-line -- disables checking till the end of the next line.
    useState<AuthWebflowContentSchemaNullable>();

  useEffect(() => {
    dispatch(getPromosContent({ page_route: route })).then((response) => {
      setSlideContent(response);
    });
  }, [route]);

  return (
    <div className={classNames(styles.wrapper, isSignupForm && styles.signup)}>
      <div className={classNames(styles.section, styles.formContent)}>
        {children}
      </div>
      <div className={classNames(styles.section, styles.promoContent)}>
        <div className={styles.carousel}>
          <div className={styles.carouselItem}>
            {!slideContent ? (
              <div className={classNames(styles.slideContent, styles.minWidth)}>
                <div className={styles.slidePromoContentLoading} />
              </div>
            ) : (
              <PromoSlide
                title={slideContent?.name}
                caption={slideContent?.caption}
                src={slideContent?.image}
                category={slideContent?.category}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Promo;
